import { PageHeader } from "components";
import { Entry } from "contentful";
import { NextPage } from "next";
import {
  DeliverySection,
  NewsHeaderSection,
  NewsletterSection,
  NewsSection,
} from "sections";
import {
  IArticleV3Fields,
  IDeliverySectionFields,
  INewsletterSectionFields,
  ITeamV3Fields,
} from "types";
import {
  fetchHeaderArticle,
  fetchNewsArticles,
  getContentfulEntries,
} from "utils/contentful-api";

const News: NextPage<{
  news: (IArticleV3Fields & { createdAt: string })[];
  team: ITeamV3Fields[];
  headerArticle: (IArticleV3Fields & { createdAt: string })[];
  newsletter: INewsletterSectionFields[];
  delivery: IDeliverySectionFields[];
}> = ({ news, headerArticle, newsletter, delivery }) => {
  return (
    <div>
      <PageHeader title="News" />
      <NewsHeaderSection articles={headerArticle} />
      <NewsSection news={news} />
      <DeliverySection deliverySection={delivery} />
      <NewsletterSection newsletterSection={newsletter} />
    </div>
  );
};
export default News;

export async function getServerSideProps() {
  const articlesRes = await fetchNewsArticles();
  const news = await articlesRes.map((p: Entry<IArticleV3Fields>) => {
    return { ...p.fields, createdAt: p.fields.dateOfPublish };
  });

  const team = await getContentfulEntries<ITeamV3Fields>(
    "teamV3",
    "sys.createdAt",
    4,
    true
  );

  const headerArticleRes = await fetchHeaderArticle();
  const headerArticle = headerArticleRes.map((p: Entry<IArticleV3Fields>) => {
    return { ...p.fields, createdAt: p.fields.dateOfPublish };
  });

  const delivery = await getContentfulEntries<IDeliverySectionFields>(
    "deliverySection"
  );

  const newsletter = await getContentfulEntries<INewsletterSectionFields>(
    "newsletterSection"
  );

  return {
    props: {
      news,
      team,
      headerArticle,
      newsletter,
      delivery,
    },
  };
}
